export default "__VITE_ASSET__J3K98Y0c__"